import styled from 'styled-components';
import COLORS, { mediaQueries } from '../../../../utils/styles';

const RawButon = styled.button`
  cursor: pointer;
  border: none;
  height: 50px;
  border-radius: 3px;
  background: ${props => (props.disabled ? COLORS.slateGray : '#304a9a')};
  color: #fff;
  font-family: 'Lato', sans-serif;
  font-weight: 400;
  width: 100%;
  font-size: 24px;
  ${mediaQueries.xs(`
  margin: 15px 0 15px 0;
`)};
`;

export default RawButon;



// WEBPACK FOOTER //
// ./src/views/sports-connect/components/Button/styled-components.js